import type { MaltaOfferedCourseEntry } from "@/src/constants/AdmissionOffice/Malta/maltaOfferedCoursesConfig";

export interface MaltaOfferedCourseFormValues {
  category?: string;
  admissionSemester?: string;
  duration?: string;
  tuitionFee?: string;
  medicalInsurance?: string;
  transfer?: string;
  tuitionFeeVisible?: boolean;
  medicalInsuranceVisible?: boolean;
  transferVisible?: boolean;
}

type SetMaltaOfferedCourseFormValue = (
  name: keyof MaltaOfferedCourseFormValues,
  value: string | boolean,
  options?: { shouldDirty?: boolean },
) => void;

export const applyMaltaOfferedCourseSelection = (
  entry: MaltaOfferedCourseEntry,
  setValue: SetMaltaOfferedCourseFormValue,
) => {
  setValue("category", entry.category, { shouldDirty: false });
  setValue("admissionSemester", entry.admissionSemester, { shouldDirty: false });
  setValue("duration", entry.duration, { shouldDirty: false });
  setValue("tuitionFee", entry.tuitionFee, { shouldDirty: false });
  setValue("tuitionFeeVisible", true, { shouldDirty: false });

  setValue("medicalInsurance", entry.medicalInsurance, { shouldDirty: false });
  setValue("medicalInsuranceVisible", true, { shouldDirty: false });

  setValue("transfer", entry.transfer, { shouldDirty: false });
  setValue("transferVisible", true, { shouldDirty: false });
};

export const clearMaltaOfferedCourseSelection = (setValue: SetMaltaOfferedCourseFormValue) => {
  setValue("category", "", { shouldDirty: false });
  setValue("admissionSemester", "", { shouldDirty: false });
  setValue("duration", "", { shouldDirty: false });
  setValue("tuitionFee", "", { shouldDirty: false });
  setValue("medicalInsurance", "", { shouldDirty: false });
  setValue("transfer", "", { shouldDirty: false });
  setValue("tuitionFeeVisible", true, { shouldDirty: false });
  setValue("medicalInsuranceVisible", true, { shouldDirty: false });
  setValue("transferVisible", true, { shouldDirty: false });
};
